/**
 * Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import Mark from 'mark.js'

export const MARKJS_CONFIG = {
  'element': 'span',
  'className': 'lui-highlight',
  'acrossElements': true,
  'separateWordSearch': false,
}

export const LuiHighlightableMixin = Superclass => class extends Superclass {
  static get markJsConfig() {
    return MARKJS_CONFIG
  }

  get higlightableElement() {
    return this
  }

  get originalInnerHTML() {
    return this._originalInnerHTML || this._setOriginalInnerHTML()
  }

  _setOriginalInnerHTML() {
    if (typeof this._originalInnerHTML === 'undefined') {
      this._originalInnerHTML = this.higlightableElement.innerHTML
    }
    return this._originalInnerHTML
  }

  _highlightClear() {
    this.higlightableElement.innerHTML = this.originalInnerHTML
  }

  _highlightApply(keyword) {
    this._highlightClear()
    if (keyword) {
      const markInstance = new Mark(this.higlightableElement)
      markInstance.mark(keyword, MARKJS_CONFIG)
    }
  }

  _isHiglightableElementAvailable() {
    return this._initialized && !!this.higlightableElement
  }

  highlight(keyword) {
    if (this._isHiglightableElementAvailable()) {
      this._highlightApply(keyword)
    } else {
      this.poll(
        this._highlightApply.bind(this, keyword),
        this._isHiglightableElementAvailable.bind(this)
      )
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-base/lui-higlightable-mixin.js
// module id = 247
// module chunks = 0 1 3